import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Table, Row, Col, Button } from "antd";
import {
  CalendarOutlined,
  CarryOutOutlined,
  UsergroupAddOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";

const EventDetailsView = () => {
  const { id } = useParams();
  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(true);

const fetchEventDetails = async () => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/admin/event/get-draft/${id}`
    );
    const data = await res.json();
    
    // Access the data from the correct path
    setEventData(data?.info); // Now this matches your backend response
    
    //console.log('Fetched event data:', data.info); // Add this for debugging
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {
    fetchEventDetails();
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (!eventData) return <p>No data found</p>;

  const { programs = [], roles = [] } = eventData;

  return (
    <div style={{ padding: 20 }}>
      <Card
        title={
          <span style={{ fontWeight: 600 }}>
            <CalendarOutlined /> Event Details
          </span>
        }
        bordered={false}
        style={{
          marginBottom: 24,
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} md={16}>
            <Row gutter={[16, 16]}>
              <Col span={8}><strong>Name:</strong> {eventData?.name}</Col>
              <Col span={8}><strong>Currency:</strong> {eventData?.currency}</Col>
              <Col span={8}><strong>Type:</strong> {eventData?.eventType}</Col>
              <Col span={8}><strong>Start:</strong> {eventData?.startDate}</Col>
              <Col span={8}><strong>End:</strong> {eventData?.endDate}</Col>
              <Col span={24}><strong>Description:</strong> {eventData?.description}</Col>
            </Row>
          </Col>
          <Col xs={24} md={8}>
            <img
              src={eventData.poster}
              alt="Event Poster"
              style={{
                width: "100%",
                borderRadius: 12,
                objectFit: "cover",
                maxHeight: 250,
              }}
            />
          </Col>
        </Row>
      </Card>

      {/* Programs */}
      <Card
        title={<span style={{ fontWeight: 600 }}><CarryOutOutlined /> Programs</span>}
        bordered={false}
        style={{
          marginBottom: 24,
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        }}
      >
        <Table
          dataSource={programs}
          columns={[
            { title: "Title", dataIndex: "title" },
            { title: "Category", dataIndex: "category" },
            { title: "Venue", dataIndex: "venueName" },
            { title: "Date", dataIndex: "date" },
            { title: "Start Time", dataIndex: "startTime" },
            { title: "End Time", dataIndex: "endTime" },
          ]}
          pagination={false}
          rowKey="id"
          bordered
          size="middle"
        />
      </Card>

      {/* Invitee Roles / Tickets */}
      <Card
        title={<span style={{ fontWeight: 600 }}><UsergroupAddOutlined /> Invitee Roles</span>}
        bordered={false}
        style={{
          marginBottom: 24,
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        }}
      >
        <Table
          dataSource={roles}
          columns={[
            { title: "Role", dataIndex: "roleName" },
            { title: "Seats", dataIndex: "totalSeats" },
            { title: "Limit/Person", dataIndex: "perPersonLimit" },
            { title: "Payment", dataIndex: "payment" },
            {
              title: "Registration Window",
              render: (_, record) => (
                <span>{record.registrationStart} → {record.registrationEnd}</span>
              ),
            },
          ]}
          expandable={{
            expandedRowRender: (role) => (
              <Table
                dataSource={role.types}
                columns={[
                  { title: "Type", dataIndex: "typeName" },
                  { title: "Seats Limit", dataIndex: "seatsLimit" },
                  { title: "Discount", dataIndex: "discount", render: (d) => `${d}%` },
                  { title: "Payment", dataIndex: "payment" },
                ]}
                pagination={false}
                rowKey="id"
                size="small"
                bordered
              />
            ),
          }}
          rowKey="id"
          pagination={false}
          bordered
          size="middle"
        />
      </Card>

      <Button
        icon={<ArrowLeftOutlined />}
        onClick={() => window.history.back()}
      >
        Back
      </Button>
    </div>
  );
};

export default EventDetailsView;
